import { Component, OnInit } from '@angular/core';
import agency from '../../../../values/agency-info.json';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  agency = agency;

  constructor(
    private _router: Router
  ) { }

  ngOnInit(): void {
  }

  public goHome(): void {
    this._router.navigate([""])
  }

}
